import b_white from '../assets/media/b-white-logo1.svg';
import b_max from '../assets/media/b-max-logo1.svg';
import ururu from '../assets/media/ururu-logo.svg';
import ozon4 from '../assets/media/ozon4.svg';
import ozon5 from '../assets/media/ozon5.svg';
import ozon6 from '../assets/media/ozon6.svg';
import ozon7 from '../assets/media/ozon7.svg';
import wb1 from '../assets/media/wb1.svg';
import wb2 from '../assets/media/wb2.svg';
import wb3 from '../assets/media/wb3.svg';
import wb4 from '../assets/media/wb4.svg';
import wb5 from '../assets/media/wb5.svg';
import wb6 from '../assets/media/wb6.svg';
import wb7 from '../assets/media/wb7.svg';
import yandex1 from '../assets/media/yandex1.svg';
import yandex2 from '../assets/media/yandex2.svg';
import yandex3 from '../assets/media/yandexEp.svg';
import yandex4 from '../assets/media/yandex4.svg';
import yandex5 from '../assets/media/yandex5.svg';
import yandex6 from '../assets/media/yandex6.svg';
import yandex7 from '../assets/media/yandex7.svg';
import yandex8 from '../assets/media/yandex8.svg';
import kaspi from '../assets/media/kaspi.png';
import ali from '../assets/media/ali.png';
import sber1 from '../assets/media/sber1.svg';
import sber2 from '../assets/media/sber2.svg';
import kuper from '../assets/media/kuper.png';

export const MAP_MARKETS = {
  ozon1: {
    title: 'Ozon B-WHITE',
    icon: b_white,
    color: '#0368ff',
  },
  ozon2: {
    title: 'Ozon B-MAX',
    icon: b_max,
    color: '#adc6ff',
  },
  ozon3: {
    title: 'Ozon U-RURU',
    icon: ururu,
    color: '#7885ee',
  },
  ozon4: {
    title: 'Ozon 4',
    icon: ozon4,
    color: '#7885ee',
  },
  ozon5: {
    title: 'Ozon 5',
    icon: ozon5,
    color: '#7885ee',
  },
  ozon6: {
    title: 'Ozon 6',
    icon: ozon6,
    color: '#7885ee',
  },
  ozon7: {
    title: 'Ozon 7',
    icon: ozon7,
    color: '#7885ee',
  },
  wb1: {
    title: 'Wildberries',
    icon: wb1,
    color: '#781286',
  },
  wb2: {
    title: 'Wildberries 2',
    icon: wb2,
    color: '#781286',
  },
  wb3: {
    title: 'Wildberries 3',
    icon: wb3,
    color: '#781286',
  },
  wb4: {
    title: 'Wildberries 4',
    icon: wb4,
    color: '#781286',
  },
  wb5: {
    title: 'Wildberries 5',
    icon: wb5,
    color: '#781286',
  },
  wb6: {
    title: 'Wildberries 6',
    icon: wb6,
    color: '#781286',
  },
  wb7: {
    title: 'Wildberries 7',
    icon: wb7,
    color: '#781286',
  },
  yandex1: {
    title: 'ЯндексМаркет B-WHITE',
    icon: yandex1,
    color: '#ffd426',
  },
  yandex2: {
    title: 'ЯндексМаркет Express',
    icon: yandex2,
    color: '#ffd426',
  },
  yandex3: {
    title: 'ЯндексМаркет U-RURU',
    icon: yandex3,
    color: '#ffd426',
  },
  yandex4: {
    title: 'ЯндексМаркет Yandex-4',
    icon: yandex4,
    color: '#ffd426',
  },
  yandex5: {
    title: 'ЯндексМаркет Yandex-5',
    icon: yandex5,
    color: '#ffd426',
  },
  yandex6: {
    title: 'ЯндексМаркет Yandex-6',
    icon: yandex6,
    color: '#ffd426',
  },
  yandex7: {
    title: 'ЯндексМаркет Yandex-7',
    icon: yandex7,
    color: '#ffd426',
  },
  yandex8: {
    title: 'ЯндексМаркет Yandex-8',
    icon: yandex8,
    color: '#ffd426',
  },
  kaspi: {
    title: 'Kaspi',
    icon: kaspi,
    color: '#ff9719',
  },
  aliexpress: {
    title: 'Aliexpress',
    icon: ali,
    color: '#e3340a',
  },
  megamarket1: {
    title: 'Мегамаркет 1',
    icon: sber1,
    color: '#299428',
  },
  megamarket2: {
    title: 'Мегамаркет 2',
    icon: sber2,
    color: '#299428',
  },
  kuper1: {
    title: 'Купер',
    icon: kuper,
    color: '#13e725',
  },
};
